import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Usuario } from './usuario';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/service/usuario.service';
import { PageEvent } from '@angular/material/paginator';
import { Perfil } from 'src/app/model/perfil';
import { PerfilService } from 'src/app/service/perfil.service';
import { Utils } from 'src/app/util/utils';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.scss']
})
export class UsuarioComponent implements OnInit {

  formulario: FormGroup;
  hide = true;
  mensagemErros: String[] = []; //array de strings dos erros retornados do backend
  usuarios: Usuario[] = [];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; // [10,20,30] quantidade de item por página
  tipoFiltro: any;
  parametroConsulta: any;
  ordemColunasTabela = ['id', 'username', 'name', 'ativo', 'acoes'];
  tipoFiltros: String[] = ['Nome',];
  perfis: Perfil[] = [];
  compararCampos = this.utils.compararCampos;

  ngOnInit(): void {
    this.montarFormulario();
    this.listarUsuarios(this.pagina, this.tamanho);
    this.consultarPerfil();
  }

  constructor(
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
    private usuarioService: UsuarioService,
    private perfilService: PerfilService,
    private utils: Utils
  ) { }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      username: [null, Validators.nullValidator],
      password: [null, Validators.nullValidator],
      name: [null, Validators.nullValidator],
      ativo: [true, Validators.nullValidator],
      perfil: [null, Validators.nullValidator],
    })
    this.tipoFiltro = "Nome";
  }

  submit() {
    //pegar os dados do formulário
    const formValues = this.formulario.value;
    // cria e adiciona no objeto
    const client: Usuario = new Usuario(
      formValues.id,
      formValues.username,
      formValues.password,
      formValues.name,
      formValues.ativo,
      formValues.perfil
    );

    if (formValues.id) {
      this.usuarioService.update(client).subscribe(resposta => {
        this.listarUsuarios(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Produto alterado com sucesso!', 'Sucesso', {
          duration: 2000
        })

      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    } else {
      // cria e adiciona no objeto
      this.usuarioService.save(client).subscribe(resposta => {
        this.listarUsuarios(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Cliente salvo com sucesso!', 'Sucesso', {
          duration: 2000
        })

      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    }
  }

  editar(id: number) {
    this.usuarioService.getById(id).subscribe((response) => {
      this.formulario.controls['id'].setValue(response.id);
      this.formulario.controls['username'].setValue(response.username);
      this.formulario.controls['password'].setValue(response.password);
      this.formulario.controls['name'].setValue(response.name);
      this.formulario.controls['ativo'].setValue(response.ativo);
      this.formulario.controls['perfil'].setValue(response.perfil);
    });
  }

  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.listarUsuarios(this.pagina, this.tamanho);
  }

  listarUsuarios(pagina: number, tamanho: number) {// definir a primeira página e o tamanho inicial
    this.usuarioService.list(pagina, tamanho).subscribe((response) => {
      this.usuarios = response.content; // pegar o conteudo do pag
      this.totalElementos = response.totalElements;// pegar o total de elementos
      this.pagina = response.number;// pegar o numero de paginas
    });
  }

  limparFormulario() {
    this.formulario.reset();
  }

  consultar() {
      this.usuarioService.buscarComFiltro(this.pagina, this.tamanho, this.parametroConsulta, this.tipoFiltro).subscribe((response) => {
        this.usuarios = response.content; // pegar o conteudo do pag
        this.totalElementos = response.totalElements;// pegar o total de elementos
        this.pagina = response.number;// pegar o numero de paginas
      });
  }

  consultarPerfil() {
    this.perfilService.buscarPerfisAtivo().subscribe((response) => {
      this.perfis = response;
    });
  }
}
